/**
 * Utilidades compartilhadas entre os tabs do Pageview.
 */

// Converte codigo ISO 2 de pais em emoji de bandeira via unicode flag characters.
export function countryFlagEmoji(code: string | null | undefined): string {
    if (!code || code.length !== 2) return '\uD83C\uDF10'; // 🌐
    const upper = code.toUpperCase();
    if (upper === 'UN' || upper === 'UNKNOWN') return '\uD83C\uDF10';
    const codePoints = upper.split('').map((c) => 127397 + c.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
}

// Mapeia um codigo de idioma pra uma bandeira representativa.
const LANGUAGE_FLAGS: Record<string, string> = {
    en: 'US',
    es: 'ES',
    pt: 'BR',
    fr: 'FR',
    de: 'DE',
    it: 'IT',
    ja: 'JP',
    zh: 'CN',
    ko: 'KR',
    ru: 'RU',
    ar: 'SA',
    nl: 'NL',
    pl: 'PL',
    tr: 'TR',
    sv: 'SE',
    no: 'NO',
    da: 'DK',
    fi: 'FI',
};

export function languageFlagEmoji(lang: string | null | undefined): string {
    if (!lang) return '\uD83C\uDF10';
    const country = LANGUAGE_FLAGS[lang.toLowerCase()];
    if (!country) return '\uD83C\uDF10';
    return countryFlagEmoji(country);
}

export function languageLabel(lang: string | null | undefined): string {
    if (!lang) return 'Sem prefixo';
    return lang.toUpperCase();
}
